module.exports = __webpack_public_path__ + "static/media/dyer_lentz.0eba41f5.jpg";